const teamMembers = [
    {
      name: "Parnia Bastany",
      role: "Urban Designer",
      img: "https://pakethorizons.ddns.net/api/files/download/parnia.jpg",
      description: (
        <>
          Frontend Web app <br />
          Web-based Model Viewer
        </>
      ),
      linkedin: "www.linkedin.com/in/parnia-bastani",
      email: "parnia.bastany@tum.de",
    },

    {
      name: "Fatemeh Ghayoumi",
      role: "Urban Planner",
      img: "https://pakethorizons.ddns.net/api/files/download/Fatemeh.jpg",
      description: (
        <>
          Environmental analysis
          <br />
          Data Management
        </>
      ),
      linkedin: "www.linkedin.com/in/fatemeh-ghayoumi-353628104",
      email: "fatemeh.ghayoumi@tum.de",
    },

    {
      name: "Melika Mirakhorli",
      role: "Urban Designer",
      img: "https://pakethorizons.ddns.net/api/files/download/Melika.jpg",
      description: (
        <>
          VC Publisher
          <br />
          Backend development
        </>
      ),
      linkedin: "https://www.linkedin.com/in/melika-mirakhorli-bb311b128/",
      email: "melika.mirakhorli@tum.de",
    },

    {
      name: "Saleem Ullah",
      role: "Civil Engineer",
      img: "https://pakethorizons.ddns.net/api/files/download/Saleem.jpeg",
      description: (
        <>
          As-built Point Cloud
          <br />
          BIM2GIS Fusion Model
        </>
      ),
      linkedin: "https://www.linkedin.com/in/saleembimit/",
      email: "saleem.ullah@tum.de",
    },
    {
      name: "Ibrahim Ipekci",
      role: "Architect",
      img: "https://pakethorizons.ddns.net/api/files/download/ibrahim.jpg",
      description: (
        <>
          Architectural Design
          <br />
          BIM Modeling
        </>
      ),
      linkedin: "https://www.linkedin.com/in/ibrahimipekci/",
      email: "ibrahim.ipekci@tum.de",
    },
  ];

  export default teamMembers;